/* eslint-disable func-names */
/* eslint-disable no-undef */
jQuery(function () {
  // Fix the <nolink> issue bugfix/DU-1569
  $(".link").each(function (i, link) {
    if (jQuery(link).attr("href") === "") {
      const spanText =
        $(this).find("span").length > 0
          ? $(this).find("span").text()
          : $(this).text();
      $(this).replaceWith($(`<span>${spanText}</span>`));
    }
  });

  if (document.querySelector(".spider")) {
    const delayInMilliseconds = 30000; // 1 second
    setTimeout(function () {
      // your code to be executed after 1 second
      document.querySelector(".spider").classList.add("show");
    }, delayInMilliseconds);
  }
  // Save link before research
  const currentUrl = window.location.href.split("?")[0];

  // Copy the link to the clipboard
  function copyFilter() {
    // Get the link text from the button
    const linkText = document.querySelector(
      ".view-header .views-display-link",
    ).href;
    let urlAfterQuery = "";
    if (linkText.includes("?")) {
      urlAfterQuery = linkText.substring(linkText.indexOf("?"));
    }

    const tooltip = document.getElementById("myTooltip");

    const templinkText = $("<textarea>")
      .attr("readonly", true)
      .val(currentUrl + urlAfterQuery);

    $("body").append(templinkText);

    templinkText.select();

    document.execCommand("copy");

    templinkText.remove();

    tooltip.innerHTML = Drupal.t("Copied to clipboard");
    tooltip.style.visibility = "visible";
  }

  $(document).on("click keydown", "#copy-filter", function (event) {
    if (
      event.type === "click" ||
      event.code === "Enter" ||
      event.code === "Space"
    ) {
      copyFilter();
      this.focus();
    }
  });
});
